//-- Copyright (c) 2021 TMT Insights Group, LLC
import { ClientConfig } from '@/__configs/config_types';
import assemblyTemplatesColumns from '@/components/AssemblyTemplates/columns';
import exceptionsColumns from '@/components/Exceptions/columns';
import transferQueueColumns from '@/components/FileManager/TransferQueue/columns';
import focusAvailsColumns from '@/components/Focus/Avails/columns';
import focusScheduleColumns from '@/components/Focus/AvailsSchedule/columns';
import focusReportsColumns from '@/components/Focus/Reports/columns';
import fileIngestColumns from '@/components/IngestManagement/columns';
import jobsColumns from '@/components/Jobs/columns';
import ordersColumns from '@/components/Orders/columns';
import pendingAssetsColumns from '@/components/PendingAssets/columns';
import processingTasksColumns from '@/components/ProcessingTasks/columns';
import profilesColumns from '@/components/Profiles/columns';
import tasksColumns from '@/components/Tasks/columns';
import jobDetailTasks from '@/components/Tasks/jobDetailTasks';
import titleDetailJobsColumns from '@/components/TitleDetail/TitleDetailRelatedJobs/columns';
import titleDetailAvailsColumns from '@/components/TitleDetail/v2/TitleDetailAvailsV2/columns';
import titlesColumns from '@/components/Titles/columns';
import titlesV2Columns from '@/components/Titles/v2/columns';
import jobDetailBundleJobsColumns from '@/components/Job/JobTabs/JobTabBundleColumns';

export const COLUMNS = {
  jobDetailTasks: () => jobDetailTasks,
  jobs: () => jobsColumns,
  orders: () => ordersColumns,
  pendingAssets: () => pendingAssetsColumns,
  processingTasks: () => processingTasksColumns,
  profiles: () => profilesColumns,
  tasks: () => tasksColumns,
  titles: () => titlesColumns, // TODO(TMT-6046): `titlesColumns` should be replaced by `titlesV2Columns`
  titlesV2: () => titlesV2Columns,
  transferQueue: () => transferQueueColumns,
  fileIngest: () => fileIngestColumns,
  titleDetailJobs: () => titleDetailJobsColumns,
  titleDetailAvails: () => titleDetailAvailsColumns,
  exceptions: () => exceptionsColumns,
  focusAvails: () => focusAvailsColumns,
  focusSchedule: () => focusScheduleColumns,
  focusReports: () => focusReportsColumns,
  assemblyTemplates: () => assemblyTemplatesColumns,
  jobDetailBundleJobs: () => jobDetailBundleJobsColumns
};

export const setUserColumns = (config: ClientConfig) => {
  Object.keys(config.columns).forEach((key: string) => {
    COLUMNS[key as keyof typeof COLUMNS] = () => config.columns[key];
  });
};
